const calculateFee = (feePercent) => (amount) =>
  feePercent * parseFloat(amount);

export default calculateFee;
        